export default __webpack_public_path__ + "fk-cp-zion/img/error-no-search-results_2353c5.png";